import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { LoanTypes } from 'services/loan/type.constansts';

interface IProps {
  loanSelected: any;
}

export const BoxPropertyDetails: React.FC<IProps> = ({ loanSelected }: IProps) => {

  const propertyType = loanSelected?.loanData? loanSelected?.loanData['What kind of property is it?']: '';
  const unitCount = 1;

  return (
    <ContentBox
      label={'Property Details'}
      content={[
        { field: 'Property Type', value: propertyType },
        ...(
          loanSelected?.type === LoanTypes.RENTAL ?
            [
              { field: 'Unit count', value: <React.Fragment>{unitCount} <span>{"View unit info ->"}</span></React.Fragment> },
            ] : []
        )
      ]}
    />
  );
}